import { Grid } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { VFC } from "react";
import { IGroup } from "../../../domain/group/group";
import { GroupDetailPomInfo } from "./group-detail-pom-info.component";
import { GroupDetailTypeInfoName } from "./group-detail-type-info-name.component";

const useStyles = makeStyles()(() => ({
  dataContainer: {
    marginTop: 15,
  },
}));

interface IGroupDetailTypeInfoProps {
  group: IGroup;
}

export const GroupDetailTypeInfo: VFC<IGroupDetailTypeInfoProps> = (props) => {
  const { group } = props;
  const { classes } = useStyles();

  return (
    <>
      <Grid container direction="column">
        <Grid item>
          <GroupDetailTypeInfoName type={group.type} />
        </Grid>
        <Grid item className={classes.dataContainer}>
          <Grid container direction="column">
            <Grid item>
              <GroupDetailPomInfo group={group} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
